import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { environment } from '../../environments/environment';

@Component({
  selector: 'app-reports',
  templateUrl: './reports.component.html',
  styleUrls: ['./reports.component.scss']
})
export class ReportsComponent implements OnInit {
  env;

  constructor(
    public router: Router,
    public route: ActivatedRoute
  ) {
    this.env = environment;
  }

  ngOnInit() {
  }

}
